module.exports = __webpack_public_path__ + "static/danihelka-fbc5f56382bca2b19d4fdb5bbb57e9c5.jpg";